import { SVGProps } from "react";

const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="1em" height="1em" fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M5 10.17.705 5.875a.998.998 0 0 1 1.41-1.411L5 7.34 11.88.46a1 1 0 0 1 1.415 1.415L5 10.17Z"
            clipRule="evenodd"
        />
    </svg>
);
export default CheckIcon;
